// Dibuja los trazos del QR canónico sobre píxeles enteros del PNG final.
// No vuelve a codificar el contenido ni utiliza una captura/interpolación de imagen.
export function dibujarQrVectorial(ctx, svg, rect, scale) {
  const box = (svg.getAttribute('viewBox') || '').trim().split(/\s+/).map(Number);
  const cells = box[2];
  const paths = [...svg.querySelectorAll('path')];
  if (box.length !== 4 || box[0] !== 0 || box[1] !== 0 || !Number.isSafeInteger(cells) || cells <= 0 || cells !== box[3] || !paths.length || svg.querySelector('image')) throw new Error('QR vectorial inválido.');
  const cellSize = Math.floor(Math.min(rect.width, rect.height) * scale / cells);
  if (cellSize < 1) throw new Error('El QR no tiene resolución suficiente.');
  const side = cells * cellSize;
  const left = Math.round((rect.x + rect.width / 2) * scale - side / 2);
  const top = Math.round((rect.y + rect.height / 2) * scale - side / 2);
  ctx.save();
  try {
    ctx.setTransform(cellSize, 0, 0, cellSize, left, top);
    for (const path of paths) {
      ctx.fillStyle = path.getAttribute('fill') || '#000000';
      ctx.fill(new Path2D(path.getAttribute('d') || ''));
    }
  } finally { ctx.restore(); }
  return { left, top, side, cellSize };
}
